import { Injectable } from '@angular/core';
import { ObjectTypeEntity } from '../object-type.entity';
import { createEntityState, GenericEntityStateClass } from '../../../state/entity.state';
import { EntityService } from '../../../services/entity.service';

export const STATE_NAME = 'objectTypeEntity';

export const ObjectTypeEntityState: GenericEntityStateClass<ObjectTypeEntity> =
  createEntityState<ObjectTypeEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class ObjectTypeEntityService extends EntityService<ObjectTypeEntity> {
  constructor() {
    super();
    this.resourceType = 'object-types';
    this.stateClass = ObjectTypeEntityState;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): ObjectTypeEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
